import DOMPurify from 'dompurify';

/**
 * Security sanitization utilities
 * Used to address Veracode SSDLC findings (CWE-80, CWE-117, CWE-601)
 */

/**
 * Sanitize HTML content for safe rendering with dangerouslySetInnerHTML
 * Prevents stored/reflected XSS (CWE-80)
 */
export const sanitizeHtml = (html) => {
  if (!html || typeof html !== 'string') return '';
  return DOMPurify.sanitize(html);
};

/**
 * Validate and sanitize a URL path segment (e.g., tenanturlname from URL params)
 * Only allows alphanumeric, hyphens, underscores, and dots
 * Prevents XSS via URL parameter injection (CWE-80)
 */
export const sanitizePathSegment = (segment) => {
  if (!segment || typeof segment !== 'string') return '';
  return segment.replace(/[^a-zA-Z0-9\-_\.]/g, '');
};

/**
 * Validate URL - only allow http, https protocols and relative paths
 * Prevents open redirect (CWE-601) and XSS via javascript: URIs
 */
export const sanitizeUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  // Allow relative URLs starting with /
  if (url.startsWith('/')) return url;
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return url;
    return '';
  } catch {
    return '';
  }
};

/**
 * Strip CRLF characters from strings before logging
 * Prevents log injection / log forging (CWE-117)
 */
export const sanitizeLogMessage = (msg) => {
  if (typeof msg !== 'string') return String(msg ?? '');
  return msg.replace(/[\r\n]+/g, ' ');
};
